import { FC, useState } from 'react';

import { ModalComponent } from 'componets/common';
import { BearLossCalculatorForm } from './BearLossCalculatorForm';
import { BearLossCalculatorResult } from './BearLossCalculatorResult';

import { saveRiskTolerance } from 'features/user/actions';

import { ModalProps } from 'models';

import { useAppDispatch, useTranslate } from 'hooks';

import styles from './index.module.scss';

interface BearLossCalculatorModalProps extends ModalProps {
	value?: string | null;
}

export const BearLossCalculatorModal: FC<BearLossCalculatorModalProps> = ({
	isOpen,
	onClose,
	value,
}) => {
	const [step, setStep] = useState(value ? 2 : 1);
	const [amount, setAmount] = useState(value ? +value : 0);
	const [isForm, setIsForm] = useState(false);

	const isResave = !!value;

	const { abilityToLossTitleText, abilityToLossCalculatorText } = useTranslate([
		'abilityToLossTitleText',
		'abilityToLossCalculatorText',
	]);

	const dispatch = useAppDispatch();
	const onCalculate = (data: any) => {
		setAmount(Math.trunc(0.1 * (Number(data.x) + Number(data.y) - Number(data.z))));
		setStep(2);
		setIsForm(true);
	};

	const onFinish = () => {
		dispatch(saveRiskTolerance({ value: amount.toString() }))
			.unwrap()
			.then(() => {
				onClose();
			})
			.catch(() => {});
	};
	return (
		<ModalComponent
			isOpen={isOpen}
			onClose={onClose}
			title={step === 1 ? abilityToLossCalculatorText : abilityToLossTitleText}
			className={styles.modal}
			width={'516px'}
		>
			<div className="modal-content">
				{step === 1 && <BearLossCalculatorForm onClose={onClose} onCalculate={onCalculate} />}
				{step === 2 && (
					<BearLossCalculatorResult
						onFinish={onFinish}
						amount={amount}
						onRecheck={() => {
							setStep(1);
						}}
						isForm={isForm}
						isResave={isResave}
					/>
				)}
			</div>
		</ModalComponent>
	);
};
